export default __webpack_public_path__ + "static/article-how-to-manage-your-money-digitally-v1-d0db4b646e34139b55d82c0c307cedbc.jpg";